import React from "react";
import { Link, Navigate } from "react-router-dom"
import { auth } from "../config/firebase";
import { useAuthContext } from "../contexts/AuthContext";
import { Button, Divider, Form, Input, message } from "antd";
import Title from "antd/es/typography/Title";
import { sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";

const inputStyle = {
    border: 'none',
    borderBottom: '2px solid #fffa8a',
    outline: 'none',
    boxShadow: 'none',
    color: '#fffa8a',
    background: "transparent"
};

export default function Login() {
    const { readUser } = useAuthContext()
    const [isProcessing, setIsProcessing] = useState(false)
    const [state, setState] = useState({ email: "", password: "" })
    const handleChange = (e) => setState({ ...state, [e.target.name]: e.target.value })
    const forgetPassword=()=>{
        let {email}=state
        if(!email)return message.error("Enter the email in email input")
        sendPasswordResetEmail(auth, email)
  .then(() => {
    setState({})
    message.success("Reset Link has been sent to your Email Check your email")
    // Password reset email sent!
    // ..
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    message.error("Enter the correct email in email input")
    // ..
  });
    }
    const handleLogin = async (e) => {
        e.preventDefault()
        let { email, password } = state
        setIsProcessing(true)
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                readUser(user);
                message.success("Logged In successfully")
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                message.error("Some Error Occurs in Log In")
            })
            .finally(() => {
                setIsProcessing(false)
            });
    }
    return (
        <>
            <main className='auth p-8 sm:p-8 md:p-12  '>

                <div className="card p-8 md:p-12   w-80 md:w-2/4 sm:w-72 rounded-xl" style={{ border: " 1px solid #fffa8a" }}>


                    <Title className='m-0 text-center ' style={{ color: "#fffa8a" }}>Login</Title>
                    <Divider style={{ backgroundColor: "gold" }} />

                    <Form layout="vertical">
                        <Form.Item label="Email" style={{ color: "#fffa8a" }}>
                            <Input className="" name='email' style={inputStyle} onChange={handleChange} />
                        </Form.Item>
                        <Form.Item label="Password" >
                            <Input type="password" className="" style={inputStyle} name='password' onChange={handleChange} />
                        </Form.Item >
                        <div className="flex justify-content-center">
                            <Button htmlType='submit' className='px-10  mx-auto text-center rounded-2xl hover:rounded-lg ' style={{ background: "transparent", border: " 1px solid #fffa8a", color: "#fffa8a" }} loading={isProcessing}
                                onClick={handleLogin}
                            >
                                Login</Button>
                        </div>

                        <Form.Item  label="Forget Password ?"  >
                            <p className="text-lg underline-offset-2 text-[#fffa8a] hover:text-[gold]" onClick={forgetPassword} >Click Here !</p>
                        </Form.Item>

                        <Form.Item label="New Here ?" >
                            <Link to={"/auth/signup"} style={{ color: "#fffa8a" }} >
                                <p className="text-3xl underline-offset-2 hover:text-[gold]" >Sign Up !</p>
                            </Link>
                        </Form.Item>
                    </Form>
                </div>
            </main>
        </>

    );
}
